export enum Environments {
    LOCAL = 'local',
    INTERNAL = 'internal',
    STAGING = 'staging',
    PRODUCTION = 'production',
}
